import { render, staticRenderFns } from "./TemplateDesignPersonal.vue?vue&type=template&id=258b27de"
import script from "./TemplateDesignPersonal.vue?vue&type=script&lang=ts"
export * from "./TemplateDesignPersonal.vue?vue&type=script&lang=ts"
import style0 from "./TemplateDesignPersonal.vue?vue&type=style&index=0&id=258b27de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports